import { Controller, useFormContext } from "react-hook-form";
import EditorInput from "./EditorInput";
import { InputBaseParams } from "../../forms/Form";
import { CropOptions } from "../../file_upload/useImageCrop";
import AttachmentsInput from "../../forms/inputs/AttachmentsInput";

const EditorAttachmentsInput = ({
  name,
  inputTitle: title,
  details,
  placeholder,
  note,
  accept,
  multiple,
  cropImage
}: InputBaseParams & {
  inputTitle: string;
  details: string;
  placeholder?: string;
  accept?: string;
  multiple?: boolean;
  note?: string;
  cropImage?: CropOptions;
}) => {
  const { control, setError, clearErrors } = useFormContext();

  return (
    <EditorInput name={name} inputTitle={title} details={details}>
      <Controller
        name={name}
        control={control}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { error }
        }) => (
          <AttachmentsInput
            accept={accept}
            multiple={multiple}
            placeholder={placeholder}
            value={value}
            note={note}
            error={error !== undefined}
            onChange={value => {
              clearErrors(name);
              onChange(value && value.length > 0 ? value : undefined);
            }}
            onBlur={onBlur}
            setError={message => setError(name, { message })}
            cropImage={cropImage}
          />
        )}
      />
    </EditorInput>
  );
};

export default EditorAttachmentsInput;
